// extracted by mini-css-extract-plugin
export default {"container":"Vo-z","brandName":"Wo-z","productName":"Xo-z","productNamePdpEnhancements":"Yo-z","breakLongProductName":"Zo-z"};